import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { AuthGate } from "./components/Auth";
import { useAuth } from "./context/useAuth";
import { useSessionWatch } from "./hooks/useSessionWatch";
import { clearTokens } from "./api";
import DemoPage from "./pages/DemoPage";
import ProfilePage from "./pages/ProfilePage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import UserGuidePage from "./pages/UserGuidePage";
import TenantUserGuidePage from "./pages/TenantUserGuidePage";

// ---------------------------------------------------------------
// AIDAS Platform – App Entry Component
// ---------------------------------------------------------------

export default function App() {
  const { user } = useAuth();
  const [isPasswordExpired, setIsPasswordExpired] = useState(false);

  // Start session watchdog
  useSessionWatch();

  useEffect(() => {
    const handlePasswordExpired = () => {
      console.warn("[App] Password expired event received.");
      setIsPasswordExpired(true);
    };

    const handlePasswordChanged = () => {
      console.log("[App] Password changed event received. Clearing restriction.");
      setIsPasswordExpired(false);
    };

    window.addEventListener('password-expired', handlePasswordExpired);
    window.addEventListener('password-changed', handlePasswordChanged);
    
    return () => {
      window.removeEventListener('password-expired', handlePasswordExpired);
      window.removeEventListener('password-changed', handlePasswordChanged);
    };
  }, []);

  // When password expires, we block the normal UI and show ONLY the profile password tab
  if (isPasswordExpired) {
    return (
      <div className="h-screen w-screen bg-gray-50 dark:bg-gray-900 flex flex-col overflow-hidden">
        <div className="bg-red-600 text-white px-6 py-3 flex justify-between items-center shadow-lg z-50">
          <div className="flex items-center gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span className="font-bold tracking-wide">MANDATORY SECURITY UPDATE: YOUR PASSWORD HAS EXPIRED</span>
          </div>
          <div className="text-sm font-medium opacity-90 italic">
            Access to the platform is restricted until your password is updated.
          </div>
        </div>
        <div className="flex-1 relative">
          <ProfilePage forceTab="password" />
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/demo/:slug" element={<DemoPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/user-guide" element={<UserGuidePage onClose={() => window.close()} />} />
      <Route path="/tenant-guide" element={<TenantUserGuidePage onClose={() => window.close()} />} />
      <Route path="*" element={<AuthGate />} />
    </Routes>
  );
}
